import { useEffect, useState } from 'react'
import moment from 'moment-timezone'
import { getConvertedDate, getDiffFromTwoTime } from '../../../utils/helper'

export const useCountDown = (screen) => {
    const [days, setDays] = useState('00')
    const [hours, setHours] = useState('00')
    const [minutes, setMinutes] = useState('00')
    const [seconds, setSeconds] = useState('00')
    let checkoutTime = 0
    let facilityTimeZone='America/New_York'

    let is_multiday_parking = null
    if(screen == 'extend'){
        const data = JSON?.parse(localStorage?.getItem('ExtendData'))
        checkoutTime = data?.checkout_datetime
        facilityTimeZone = data?.facility?.timezone || 'America/New_York'
        is_multiday_parking = data?.facility?.is_multiday_parking || '0'
    }else{
        const data = JSON.parse(localStorage?.getItem('paymentRecipt'))
        checkoutTime = data?.checkout_datetime
        facilityTimeZone = data?.facility?.timezone || 'America/New_York'
        is_multiday_parking = data?.facility?.is_multiday_parking || '0'
    }
    const [timerCLean, setTimerClean] = useState(0)
    useEffect(() => {

        let countDownDate = new Date(getConvertedDate(checkoutTime))
        let countDownDateinSec = countDownDate.getTime()
        // Update the count down every 1 second
        const x = setInterval(function() {

            // Get today's date and time
            // const now = new Date().getTime()
            let now = new Date(moment(new Date()).tz(facilityTimeZone).format('YYYY-MM-DD HH:mm:ss'))
            let nowinSec = now.getTime()
            // old calculation
            //const now = new Date(new Date().toLocaleString('en-US',{timeZone: 'GMT'})).getTime() - 4*3600*1000
            
            // Find the distance between now and the count down date
            const distance = (countDownDateinSec - nowinSec) + 60000
            const locminutes = getDiffFromTwoTime(countDownDate, screen)
            // Time calculations for days, hours, minutes and seconds
            if(locminutes > 0){
                if(is_multiday_parking == '1'){
                    setDays(Math.floor(locminutes / (24 * 60)))
                    setHours(Math.floor((locminutes % (24 * 60)) / 60))
                } else {
                    setHours(Number(Math.floor(locminutes / (24 * 60)) * 24) + Number(Math.floor((locminutes % (24 * 60)) / 60)))
                }
                setMinutes(Math.floor(locminutes % 60))
                setSeconds(Math.floor((distance % (1000 * 60)) / 1000))
            }
            
                
            // If the count down is over, write some text 
            if (locminutes < 0) {
                setTimerClean(timerCLean + 1)
                if(timerCLean > 0) {
                    clearInterval(x)
                }
            }

        }, 1000)
        return () => {
            clearInterval(x)
        }
    },[days, hours, minutes, seconds])
    
   
    return [days, hours, minutes, seconds]
  }